'use client';

import { useMemo } from 'react';
import ContentletFilter from '@/components/shared/contentletFilter';
import { CollectionMosaicCard } from './components/collectionMosaicCard';
import { useDeviceTypeContext } from '@/app/utils/getDeviceType';

/**
 * This function returns a string with the inodes of the contentlets
 *
 * @param {*} [contentlets=[]]
 * @return {*}
 */

export function MosaicCollection({ contentVariable, widgetCodeJSON }) {
    const deviceType = useDeviceTypeContext();
    const { posts, query, sortBy, total } = widgetCodeJSON;

    const queryConfig = useMemo(
        () => ({
            sortBy,
            defaultQuery: `${query}`,
            searchQuery: query || ''
        }),
        [sortBy, query]
    );

    if (!posts?.length) return null;

    const initialCollection = {
        contentlets: [...posts],
        total
    };

    return (
        <div className="container m-auto flex w-full flex-col">
            <ContentletFilter
                Card={({ contentlet, ...props }) => (
                    <CollectionMosaicCard
                        contentlet={contentlet}
                        contenttype={contentVariable}
                        {...props}
                    />
                )}
                hideFilter
                hideSearchBar
                showCategoryFromSlug={false}
                limit={posts.length}
                queryConfig={queryConfig}
                mosaicStyle
                initialCollection={initialCollection}
                contentType={contentVariable}
                deviceType={deviceType}
            />
        </div>
    );
}
